import { createReducer, on } from '@ngrx/store';
import { AccessPassState } from './access-pass.state';
import { FilteredAccessPassesDomainEvent } from './access-pass.events';
import { FilterAccessPassesCommand } from './access-pass.commands';
import { Id } from '@resident-select/domain/core';

export const accessPassKey = 'accessPass';

const initialState: AccessPassState = {
  entities: {},
  byQuery: {},
};

export const accessPassReducer = createReducer(
  initialState,
  on(FilteredAccessPassesDomainEvent, (state, { data, transactionId }) => {
    console.log('data, transactionId');
    console.log(data, transactionId);

    if (!data) {
      return state;
    }
    const oldEntities = { ...state.entities };
    const oldFilters = { ...state.byQuery };

    const pasess: Id[] = [];
    for (const element of data) {
      for (const item of element.accessPasses) {
        oldEntities[item.id] = item;
        pasess.push(item.id);
      }
    }
    oldFilters[transactionId] = pasess;
    return {
      ...state,
      entities: oldEntities,
      byQuery: oldFilters,
    };
  }),

  on(FilterAccessPassesCommand, (state, { transactionId }) => {
    const oldFilters = { ...state.byQuery };
    oldFilters[transactionId] = undefined;
    return {
      ...state,
      byFilter: oldFilters,
    };
  }),
);
